import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import {  FeatureSection} from './StyledFeatures';
import {Title} from "../../Common/PageElement";

function Cite() {
    return (
        <FeatureSection id="cite" height="fit">

            <Container>
                <Title align="center">CITE US</Title>
                {/*Xin Wei, Huagang Tan, Briallen Lobb, William Zhen, Zijing Wu, Donovan H. Parks, Josh D. Neufeld,*/}
                {/*Gabriel Moreno-Hagelsieb, Andrew C. Doxey. "AnnoView enables large-scale analysis, comparison,*/}
                {/*and visualization of microbial gene neighborhoods." bioRxiv. doi:*/}
                Xin Wei, Huagang Tan, Briallen Lobb, William Zhen, Zijing Wu, Donovan H Parks, Josh D Neufeld, Gabriel Moreno-Hagelsieb, Andrew C Doxey. (2024) AnnoView enables large-scale analysis, comparison, and visualization of microbial gene neighborhoods. Briefings in Bioinformatics. 25(3):bbae229.
                <br/>
                <a href="https://doi.org/10.1093/bib/bbae229" style={{ color:'white', fontWeight: 'bold', textDecoration: 'underline' }}>
                    https://doi.org/10.1093/bib/bbae229
                </a>

            </Container>
        </FeatureSection>
    )

}

export default Cite
